<template>
  <div>
    <el-table
      :data="claimsByLabel.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100 cursor-pointer"
      stripe
      v-loading="loading"
      @row-click="handleRowClick"
    >
      <el-table-column label="Label" prop="label" sortable></el-table-column>
      <el-table-column label="Licence - YES" prop="log_count_yes" sortable></el-table-column>
      <el-table-column label="Licence - NO" prop="log_count_no" sortable></el-table-column>
      <el-table-column label="Licence - Check Manually" prop="log_count_manual" sortable></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeClaimLog', [
      'claimsByLabel',
      'loading',
      'order_column',
      'order_type',
      'page_size'
    ])
  },

  methods: {
    ...mapMutations('youtubeClaimLog', ['setPage', 'setDialog', 'setSelectedLabel', "setShowDetails"]),
    ...mapActions('youtubeClaimLog', ['read', 'getDetails', "getTodayClaims"]),
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.read()
    },
    handleRowClick (row) {
      this.setSelectedLabel(row.label)
      this.getDetails()
      this.setShowDetails(true)
    }
  },

  created() {
    this.read()
    this.getTodayClaims()
  }
}
</script>
<style>
.cursor-pointer {
  cursor: pointer;
}
</style>
